import { ApiService } from '../../services/api.service';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  @Input() currentPage: number = 1;
  @Input() itemsPerPage: number = 5;
  @Input() totalItems: number = 0; // Total items returned by the API
  @Input() totalPages: number = 1; // Total pages from the API

  @Output() pageChange = new EventEmitter<number>();

  get paginatedItems() {
    // Simply return the current items being displayed (handled by TableGuruComponent)
    return [];
  }

  get pageNumbers(): (number | string)[] {
    const totalPages = this.totalPages;
    const pages: (number | string)[] = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (this.currentPage > 3) {
        pages.push(1, '...');
      } else {
        for (let i = 1; i <= 3; i++) {
          pages.push(i);
        }
      }

      if (this.currentPage > 3 && this.currentPage < totalPages - 2) {
        pages.push(this.currentPage);
      }

      if (this.currentPage < totalPages - 2) {
        pages.push('...', totalPages);
      } else {
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(i);
        }
      }
    }

    return pages;
  }

  get resultRange(): string {
    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(start + this.itemsPerPage - 1, this.totalItems);
    return `${start} - ${end}`;
  }

  goToPage(page: any) {
    console.dir(this.currentPage);
    console.dir(this.totalPages);
    if (page > 0 && page <= this.totalPages) {
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.pageChange.emit(this.currentPage);
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageChange.emit(this.currentPage);
    }
  }

  ceil(val: number) {
    return Math.ceil(val);
  }
}